import { queryClient } from '@alfa-bank/newclick-global';
import { getQueryKeyFromApiMethod } from '../get-query-key-from-api-method';
/**
 * Возвращает данные из кеша react-query на основе интерфейса @type {ApiMethod}
 */
export const getCachedDataFromApiMethod = (apiMethod, options) => {
    const response = queryClient.getQueryData(getQueryKeyFromApiMethod(apiMethod, options?.params));
    return response || undefined;
};
